<template>
    <div class="component-wrap">
        <div v-for="(item, index) in list" :key="index" class="table_item h06-py-cinema-item-click" @click="onClick(item)">
            <div class="item_header fx-row fx-between fx-center">
                <div class="name fx-fill txt-ellipsis">{{item.name}}</div>
                <div v-if="item.minPrice" class="price fc-tips">
                    <span class="fc-active">{{item.minPrice}}</span> 起
                </div>
            </div>
            <div class="item_footer fx-row fx-between fx-center">
                <div class="address fx-fill txt-ellipsis">{{item.address}}</div>
                <div class="distance fc-tips">{{item.distance | formatDistance}}</div>
            </div>
            <div v-if="item.recentlyOpi" style="padding-top: 5px;">
                <div class="fc-tips">最近场次
                    <span>{{item.recentlyOpi}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: Array,
    },
    data() {
        return {}
    },
    methods: {
        onClick(item) {
            this.$emit('click', item.id);
        }
    }
}
</script>

<style lang="scss" scoped>
.component-wrap {
	padding: 0 15px;
	.table_item {
		background-color: #fff;
		width: 100%;
		border-radius: 2px;
		padding: 10px 12px;
		margin: 10px 0;
		.item_header {
			padding-bottom: 5px;
		}
		.item_footer {
			padding-top: 5px;
		}
		.name {
			font-size: 16px;
			color: #3f4956;
			// font-family: "pf medium";
		}
		.address {
			color: $tips-color;
		}
	}
}
</style>
